import React, { useEffect, useState } from 'react';

const SLIDES = [
  {
    keyword1: 'GIFTS',
    keyword2: 'BUSINESS',
    color: '#007bff',
  },
  {
    keyword1: 'GIFTS',
    keyword2: 'PEOPLE',
    color: '#006400',
  },
  {
    keyword1: 'GIFTS',
    keyword2: 'VALUES',
    color: '#8B0000',
  },
];

function TaglineSection() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % SLIDES.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const slide = SLIDES[index];

  return (
    <section className="tagline-section">
      <h2>
        <span className="big-word" style={{ color: slide.color }}>{slide.keyword1}</span>{' '}
        <span className="small-text">that speaks</span>
      </h2>
      <h2>
        <span className="large-text">for your</span>{' '}
        <span className="big-word" style={{ color: slide.color }}>{slide.keyword2}</span>
      </h2>
    </section>
  );
}

export default TaglineSection;
